import React from 'react';
import styles from './MonthNavigator.module.css';

const MonthNavigator = ({ year, month, onPrev, onNext }) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  return (
    <div className={styles.navigator}>
      <button onClick={onPrev} className={styles.navButton}>◀ Prev</button>
      <h2 className={styles.monthYear}>
        {monthNames[month]} {year}
      </h2>
      <button onClick={onNext} className={styles.navButton}>Next ▶</button>
    </div>
  );
};

export default MonthNavigator;